import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { Clock, Trophy, Target } from 'lucide-react';

interface CurrentPathCardProps {
  path: {
    id: string;
    title: string;
    description: string;
    progress: number;
    estimatedTime: string;
    nextMilestone?: {
      title: string;
      reward: number;
    };
  };
}

export function CurrentPathCard({ path }: CurrentPathCardProps) {
  return (
    <Card className="bg-primary-50 border-primary-200">
      <CardHeader>
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-lg font-semibold text-primary-900">Current Focus</h3>
            <p className="text-primary-800">{path.title}</p>
          </div>
          <Badge variant="secondary" className="bg-primary-100 text-primary-800">
            Active
          </Badge>
        </div>
      </CardHeader>
      
      <CardContent className="space-y-4">
        <p className="text-sm text-primary-700">{path.description}</p>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-primary-900">
            <span>Overall Progress</span>
            <span>{path.progress}%</span>
          </div>
          <Progress value={path.progress} className="h-2" />
        </div>

        <div className="flex items-center gap-4 text-sm text-primary-700">
          <div className="flex items-center gap-1">
            <Clock className="h-4 w-4" />
            {path.estimatedTime} remaining
          </div>
          {path.nextMilestone && (
            <div className="flex items-center gap-1">
              <Target className="h-4 w-4" />
              Next: {path.nextMilestone.title}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
} 